import { i18n } from "@/i18n";

/**
 * Map Firebase Auth error codes to user-facing messages for the email/password
 * flows (sign-in, register, reset, change password). Unknown codes fall back to
 * a generic message.
 *
 * Resolves against the global i18n instance rather than a `t` from a hook: the
 * result is captured into component state at the moment of the failure, so it
 * behaves like a toast — it keeps the wording it was raised with.
 */
const MESSAGE_KEYS: Record<string, string> = {
  "auth/invalid-email": "auth:firebase.invalidEmail",
  "auth/user-disabled": "auth:firebase.userDisabled",
  "auth/user-not-found": "auth:firebase.userNotFound",
  "auth/wrong-password": "auth:firebase.wrongPassword",
  "auth/invalid-credential": "auth:firebase.invalidCredential",
  "auth/email-already-in-use": "auth:firebase.emailAlreadyInUse",
  "auth/weak-password": "auth:firebase.weakPassword",
  "auth/too-many-requests": "auth:firebase.tooManyRequests",
  "auth/operation-not-allowed": "auth:firebase.operationNotAllowed",
  "auth/requires-recent-login": "auth:firebase.requiresRecentLogin",
  "auth/network-request-failed": "auth:firebase.networkRequestFailed",
};

export function firebaseAuthMessage(code: string | undefined, fallback?: string): string {
  const generic = fallback ?? i18n.t("auth:firebase.generic");
  if (!code) return generic;
  const key = MESSAGE_KEYS[code];
  if (!key) return generic;
  return i18n.t(key);
}
